import {
  FullLogoIcon,
  LogoDarkIcon,
  LogoWhiteIcon,
  SingPlusGradientIcon,
  SingPlusIcon,
  SingPlusWordLogoIcon,
} from "./brand/icons";
import { iconCategories } from "./categories";
import { BankIcon, LinkIcon, WalletIcon } from "./commerce/icons";
import {
  BibleIcon,
  ChurchIcon,
  ExploreMoreIcon,
  HeadphonesIcon,
  OpenBookIcon,
  TrendingItemsIcon,
  UpArrow,
} from "./content/icons";
import { EnglishFlagIcon, SpanishFlagIcon } from "./flags/icons";
import {
  ChapterMenuIcon,
  CheckMarkIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CloseIcon,
  EllipsisHorizontalIcon,
  GlobeIcon,
  HeartFilledIcon,
  HeartIcon,
  HomeIcon,
  InfoCircleIcon,
  MinusIcon,
  OpenLinkIcon,
  PinIcon,
  PlusIcon,
  QuestionMarkIcon,
  SearchIcon,
  SidebarToggleIcon,
  SortIcon,
  WarningIcon,
} from "./general/icons";
import {
  GiftBoxAcceptedIcon,
  GiftBoxGraphicIcon,
  GiftBoxIcon,
  GiftIcon,
} from "./gifting/icons";
import {
  ContinueIcon,
  EpisodeCheckedIcon,
  EpisodeUncheckedIcon,
  ForwardTenIcon,
  ListenAgainIcon,
  PauseIcon,
  PlayIcon,
  PlayingIcon,
  PlayVideoIcon,
  ReplayTenIcon,
  VolumeHighIcon,
  VolumeLowIcon,
  VolumeMediumIcon,
  VolumeMutedIcon,
} from "./playback/icons";
import {
  CopyPasteIcons,
  MessageIcon,
  NoImageIcon,
  QrCodeIcon,
  SharedDevosIcon,
  SharingIcon,
  UsersIcon,
} from "./sharing/icons";
import {
  ArchiveIcon,
  BellIcon,
  CalendarIcon,
  LightningBoltIcon,
  LockIcon,
  LogoutIcon,
  MagnifyingGlassIcon,
  PenIcon,
  PlusBoxedIcon,
  ProfileIcon,
  SubscriptionIcon,
} from "./system/icons";
import type { IconRegistryEntry } from "./types";

export const sharedIconRegistry = [
  {
    name: "FullLogoIcon",
    Component: FullLogoIcon,
    category: "brand",
    keywords: ["logo", "brand", "worship", "devo"],
    source: "app/components/icons/brandLogoIcons.tsx",
  },
  {
    name: "LogoWhiteIcon",
    Component: LogoWhiteIcon,
    category: "brand",
    keywords: ["logo", "white", "brand"],
    source: "app/components/icons/brandLogoIcons.tsx",
  },
  {
    name: "LogoDarkIcon",
    Component: LogoDarkIcon,
    category: "brand",
    keywords: ["logo", "dark", "brand"],
    source: "app/components/icons/brandLogoIcons.tsx",
  },
  {
    name: "SingPlusIcon",
    Component: SingPlusIcon,
    category: "brand",
    keywords: ["sing+", "brand", "subscription"],
    source: "app/components/icons/brandLogoIcons.tsx",
  },
  {
    name: "SingPlusWordLogoIcon",
    Component: SingPlusWordLogoIcon,
    category: "brand",
    keywords: ["sing+", "wordmark", "brand"],
    source: "app/components/icons/brandLogoIcons.tsx",
  },
  {
    name: "SingPlusGradientIcon",
    Component: SingPlusGradientIcon,
    category: "brand",
    keywords: ["sing+", "gradient", "brand", "logo"],
    source: "packages/ui/src/icons/brand/icons.tsx",
  },
  {
    name: "PlayIcon",
    Component: PlayIcon,
    category: "playback",
    keywords: ["play", "audio", "video"],
    source: "app/components/icons/playIcon.tsx",
  },
  {
    name: "PlayingIcon",
    Component: PlayingIcon,
    category: "playback",
    keywords: ["playing", "audio", "equalizer"],
    source: "app/components/icons/playingIcon.tsx",
  },
  {
    name: "ContinueIcon",
    Component: ContinueIcon,
    category: "playback",
    keywords: ["continue", "resume", "listen"],
    source: "app/components/icons/playbackIcons.tsx",
  },
  {
    name: "PauseIcon",
    Component: PauseIcon,
    category: "playback",
    keywords: ["pause", "audio"],
    source: "app/components/icons/playbackIcons.tsx",
  },
  {
    name: "ReplayTenIcon",
    Component: ReplayTenIcon,
    category: "playback",
    keywords: ["replay", "10", "seek"],
    source: "app/components/icons/playbackIcons.tsx",
  },
  {
    name: "ForwardTenIcon",
    Component: ForwardTenIcon,
    category: "playback",
    keywords: ["forward", "10", "seek"],
    source: "app/components/icons/playbackIcons.tsx",
  },
  {
    name: "EpisodeCheckedIcon",
    Component: EpisodeCheckedIcon,
    category: "playback",
    keywords: ["episode", "complete", "checked"],
    source: "app/components/icons/playbackIcons.tsx",
  },
  {
    name: "EpisodeUncheckedIcon",
    Component: EpisodeUncheckedIcon,
    category: "playback",
    keywords: ["episode", "incomplete", "unchecked"],
    source: "app/components/icons/playbackIcons.tsx",
  },
  {
    name: "PlayVideoIcon",
    Component: PlayVideoIcon,
    category: "playback",
    keywords: ["play", "video", "hero"],
    source: "app/components/icons/playbackIcons.tsx",
  },
  {
    name: "ListenAgainIcon",
    Component: ListenAgainIcon,
    category: "playback",
    keywords: ["listen", "again", "replay"],
    source: "app/components/icons/playbackIcons.tsx",
  },
  {
    name: "VolumeHighIcon",
    Component: VolumeHighIcon,
    category: "playback",
    keywords: ["volume", "audio", "speaker", "high"],
    source: "packages/ui/src/icons/playback/icons.tsx",
  },
  {
    name: "VolumeMediumIcon",
    Component: VolumeMediumIcon,
    category: "playback",
    keywords: ["volume", "audio", "speaker", "medium"],
    source: "packages/ui/src/icons/playback/icons.tsx",
  },
  {
    name: "VolumeLowIcon",
    Component: VolumeLowIcon,
    category: "playback",
    keywords: ["volume", "audio", "speaker", "low"],
    source: "packages/ui/src/icons/playback/icons.tsx",
  },
  {
    name: "VolumeMutedIcon",
    Component: VolumeMutedIcon,
    category: "playback",
    keywords: ["volume", "audio", "speaker", "muted"],
    source: "packages/ui/src/icons/playback/icons.tsx",
  },
  {
    name: "SearchIcon",
    Component: SearchIcon,
    category: "general",
    keywords: ["search", "magnify"],
    source: "packages/ui/src/icons/app-ui-icons.tsx",
  },
  {
    name: "SortIcon",
    Component: SortIcon,
    category: "general",
    keywords: ["sort", "filter"],
    source: "packages/ui/src/icons/app-ui-icons.tsx",
  },
  {
    name: "PinIcon",
    Component: PinIcon,
    category: "general",
    keywords: ["pin", "save"],
    source: "packages/ui/src/icons/app-ui-icons.tsx",
  },
  {
    name: "HomeIcon",
    Component: HomeIcon,
    category: "general",
    keywords: ["home", "house", "navigation"],
    source: "packages/ui/src/icons/general/icons.tsx",
  },
  {
    name: "ChapterMenuIcon",
    Component: ChapterMenuIcon,
    category: "general",
    keywords: ["chapter", "menu", "list", "sections"],
    source: "packages/ui/src/icons/general/icons.tsx",
  },
  {
    name: "CloseIcon",
    Component: CloseIcon,
    category: "general",
    keywords: ["close", "dismiss", "x"],
    source: "app/components/icons/closeIcon.tsx",
  },
  {
    name: "ChevronLeftIcon",
    Component: ChevronLeftIcon,
    category: "general",
    keywords: ["chevron", "left", "back"],
    source: "app/components/icons/chevronLeftIcon.tsx",
  },
  {
    name: "ChevronRightIcon",
    Component: ChevronRightIcon,
    category: "general",
    keywords: ["chevron", "right", "next"],
    source: "app/components/icons/chevronRightIcon.tsx",
  },
  {
    name: "WarningIcon",
    Component: WarningIcon,
    category: "general",
    keywords: ["warning", "alert", "error"],
    source: "app/components/icons/warningIcon.tsx",
  },
  {
    name: "CheckMarkIcon",
    Component: CheckMarkIcon,
    category: "general",
    keywords: ["check", "success", "done"],
    source: "app/components/icons/checkMarkIcon.tsx",
  },
  {
    name: "HeartIcon",
    Component: HeartIcon,
    category: "general",
    keywords: ["heart", "favorite", "like"],
    source: "app/components/icons/heartIcon.tsx",
  },
  {
    name: "HeartFilledIcon",
    Component: HeartFilledIcon,
    category: "general",
    keywords: ["heart", "favorite", "filled"],
    source: "app/components/icons/heartFilledIcon.tsx",
  },
  {
    name: "GlobeIcon",
    Component: GlobeIcon,
    category: "general",
    keywords: ["globe", "world", "timezone"],
    source: "app/components/icons/globeIcon.tsx",
  },
  {
    name: "InfoCircleIcon",
    Component: InfoCircleIcon,
    category: "general",
    keywords: ["info", "information", "help", "tooltip"],
    source: "packages/ui/src/icons/general/icons.tsx",
  },
  {
    name: "QuestionMarkIcon",
    Component: QuestionMarkIcon,
    category: "general",
    keywords: ["question", "help"],
    source: "app/components/icons/questionMarkIcon.tsx",
  },
  {
    name: "PlusIcon",
    Component: PlusIcon,
    category: "general",
    keywords: ["plus", "add"],
    source: "app/components/icons/plusIcon.tsx",
  },
  {
    name: "MinusIcon",
    Component: MinusIcon,
    category: "general",
    keywords: ["minus", "remove"],
    source: "app/components/icons/minusIcon.tsx",
  },
  {
    name: "EllipsisHorizontalIcon",
    Component: EllipsisHorizontalIcon,
    category: "general",
    keywords: ["ellipsis", "more", "menu"],
    source: "app/components/icons/ellipsisHorizontalIcon.tsx",
  },
  {
    name: "OpenLinkIcon",
    Component: OpenLinkIcon,
    category: "general",
    keywords: ["link", "external", "open"],
    source: "app/components/icons/openLinkIcon.tsx",
  },
  {
    name: "SidebarToggleIcon",
    Component: SidebarToggleIcon,
    category: "general",
    keywords: ["sidebar", "toggle", "collapse", "expand", "panel"],
    source: "packages/ui/src/icons/general/icons.tsx",
  },
  {
    name: "BankIcon",
    Component: BankIcon,
    category: "commerce",
    keywords: ["bank", "payment", "account"],
    source: "app/components/icons/bankIcon.tsx",
  },
  {
    name: "WalletIcon",
    Component: WalletIcon,
    category: "commerce",
    keywords: ["wallet", "payment"],
    source: "app/components/icons/walletIcon.tsx",
  },
  {
    name: "LinkIcon",
    Component: LinkIcon,
    category: "commerce",
    keywords: ["link", "payment", "stripe"],
    source: "app/components/icons/linkIcon.tsx",
  },
  {
    name: "ArchiveIcon",
    Component: ArchiveIcon,
    category: "general",
    keywords: ["archive", "save", "settings"],
    source: "app/components/icons/archiveIcon.tsx",
  },
  {
    name: "BellIcon",
    Component: BellIcon,
    category: "general",
    keywords: ["bell", "notification", "alert"],
    source: "app/components/icons/bellIcon.tsx",
  },
  {
    name: "CalendarIcon",
    Component: CalendarIcon,
    category: "general",
    keywords: ["calendar", "date", "streak"],
    source: "app/components/icons/calendarIcon.tsx",
  },
  {
    name: "LightningBoltIcon",
    Component: LightningBoltIcon,
    category: "general",
    keywords: ["lightning", "streak", "energy"],
    source: "app/components/icons/lightningBolt.tsx",
  },
  {
    name: "LockIcon",
    Component: LockIcon,
    category: "general",
    keywords: ["lock", "secure", "gated"],
    source: "app/components/icons/lockIcon.tsx",
  },
  {
    name: "LogoutIcon",
    Component: LogoutIcon,
    category: "general",
    keywords: ["logout", "signout", "account"],
    source: "app/components/icons/logoutIcon.tsx",
  },
  {
    name: "MagnifyingGlassIcon",
    Component: MagnifyingGlassIcon,
    category: "general",
    keywords: ["search", "magnifying", "query"],
    source: "app/components/icons/magnifyingGlassIcon.tsx",
  },
  {
    name: "PenIcon",
    Component: PenIcon,
    category: "general",
    keywords: ["pen", "edit", "write"],
    source: "app/components/icons/penIcon.tsx",
  },
  {
    name: "PlusBoxedIcon",
    Component: PlusBoxedIcon,
    category: "general",
    keywords: ["plus", "boxed", "upgrade"],
    source: "app/components/icons/plusBoxedIcon.tsx",
  },
  {
    name: "ProfileIcon",
    Component: ProfileIcon,
    category: "general",
    keywords: ["profile", "account", "user"],
    source: "app/components/icons/profileIcon.tsx",
  },
  {
    name: "SubscriptionIcon",
    Component: SubscriptionIcon,
    category: "general",
    keywords: ["subscription", "membership", "account"],
    source: "app/components/icons/subscriptionIcon.tsx",
  },
  {
    name: "BibleIcon",
    Component: BibleIcon,
    category: "content",
    keywords: ["bible", "scripture", "reading"],
    source: "app/components/icons/bibleIcon.tsx",
  },
  {
    name: "ChurchIcon",
    Component: ChurchIcon,
    category: "content",
    keywords: ["church", "community", "location"],
    source: "app/components/icons/churchIcon.tsx",
  },
  {
    name: "ExploreMoreIcon",
    Component: ExploreMoreIcon,
    category: "content",
    keywords: ["explore", "discover", "browse"],
    source: "app/components/icons/exploreMoreIcon.tsx",
  },
  {
    name: "HeadphonesIcon",
    Component: HeadphonesIcon,
    category: "content",
    keywords: ["headphones", "listen", "audio"],
    source: "app/components/icons/headphonesIcon.tsx",
  },
  {
    name: "OpenBookIcon",
    Component: OpenBookIcon,
    category: "content",
    keywords: ["book", "open", "reading", "content"],
    source: "app/components/icons/openBookIcon.tsx",
  },
  {
    name: "TrendingItemsIcon",
    Component: TrendingItemsIcon,
    category: "content",
    keywords: ["trending", "popular", "growth"],
    source: "app/components/icons/trendingItemsIcon.tsx",
  },
  {
    name: "UpArrow",
    Component: UpArrow,
    category: "content",
    keywords: ["up", "arrow", "scroll"],
    source: "app/components/icons/upArrow.tsx",
  },
  {
    name: "CopyPasteIcons",
    Component: CopyPasteIcons,
    category: "sharing",
    keywords: ["copy", "paste", "clipboard"],
    source: "app/components/icons/copyPasteIcon.tsx",
  },
  {
    name: "MessageIcon",
    Component: MessageIcon,
    category: "sharing",
    keywords: ["message", "text", "sms"],
    source: "app/components/icons/messageIcon.tsx",
  },
  {
    name: "NoImageIcon",
    Component: NoImageIcon,
    category: "sharing",
    keywords: ["no image", "share", "media"],
    source: "app/components/icons/noImageIcon.tsx",
  },
  {
    name: "QrCodeIcon",
    Component: QrCodeIcon,
    category: "sharing",
    keywords: ["qr", "code", "scan"],
    source: "app/components/icons/qrcodeIcon.tsx",
  },
  {
    name: "SharedDevosIcon",
    Component: SharedDevosIcon,
    category: "sharing",
    keywords: ["shared", "devos", "activity"],
    source: "app/components/icons/sharedDevosIcon.tsx",
  },
  {
    name: "SharingIcon",
    Component: SharingIcon,
    category: "sharing",
    keywords: ["share", "send", "export"],
    source: "app/components/icons/sharingIcon.tsx",
  },
  {
    name: "UsersIcon",
    Component: UsersIcon,
    category: "sharing",
    keywords: ["users", "people", "community"],
    source: "app/components/icons/usersIcon.tsx",
  },
  {
    name: "GiftBoxGraphicIcon",
    Component: GiftBoxGraphicIcon,
    category: "gifting",
    keywords: ["gift", "box", "graphic"],
    source: "app/components/icons/giftBoxGraphicIcon.tsx",
  },
  {
    name: "GiftBoxIcon",
    Component: GiftBoxIcon,
    category: "gifting",
    keywords: ["gift", "box", "present"],
    source: "app/components/icons/giftBoxIcon.tsx",
  },
  {
    name: "GiftIcon",
    Component: GiftIcon,
    category: "gifting",
    keywords: ["gift", "present", "coupon"],
    source: "app/components/icons/giftIcon.tsx",
  },
  {
    name: "GiftBoxAcceptedIcon",
    Component: GiftBoxAcceptedIcon,
    category: "gifting",
    keywords: ["gift", "accepted", "redeemed"],
    source: "app/components/icons/gitBoxAcceptedIcon.tsx",
  },
  {
    name: "EnglishFlagIcon",
    Component: EnglishFlagIcon,
    category: "flags",
    keywords: ["flag", "english", "usa", "united states", "language"],
    source: "packages/ui/src/icons/flags/icons.tsx",
  },
  {
    name: "SpanishFlagIcon",
    Component: SpanishFlagIcon,
    category: "flags",
    keywords: ["flag", "spanish", "spain", "language", "español"],
    source: "packages/ui/src/icons/flags/icons.tsx",
  },
] as const satisfies readonly IconRegistryEntry[];

export const sharedIconsByCategory = iconCategories.reduce(
  (accumulator, category) => {
    accumulator[category] = sharedIconRegistry.filter(
      (icon) => icon.category === category,
    );
    return accumulator;
  },
  {} as Record<(typeof iconCategories)[number], IconRegistryEntry[]>,
);
